import React, { useEffect, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import Label from '../Label';
import useTranslation from '../../../hooks/translation-hook';
import { useQualityWarning } from '../../../hooks/useQualityWarning';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faChevronRight, faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

export function QualityWarningAvatarBadge() {
  const { warning } = useQualityWarning();
  const t = useTranslation();
  return warning ? <View testID="quality-warning-avatar" accessibilityRole="image" accessibilityLabel={t('quality-warning-avatar-label')}
    style={{ position: 'absolute', right: -4, bottom: -4, width: 18, height: 18, borderRadius: 9,
      alignItems: 'center', justifyContent: 'center', backgroundColor: '#F5A523', borderColor: '#035164', borderWidth: 1 }}>
    <Label style={{ color: '#111111', fontWeight: '800', fontSize: 13, lineHeight: 16 }}>!</Label>
  </View> : null;
}

export default function QualityWarningIndicator({ embedded = false }: { embedded?: boolean }) {
  const { warning, refresh, open } = useQualityWarning();
  const t = useTranslation();
  const [focused, setFocused] = useState(false);
  useEffect(() => { void refresh().catch(() => {}); }, [refresh]);
  return warning ? <View testID="quality-warning-profile" style={{ backgroundColor: '#FFF0D5', paddingHorizontal: embedded ? 16 : 12, paddingVertical: 12,
    borderRadius: embedded ? 0 : 8, gap: embedded ? 8 : 6, marginTop: embedded ? 0 : 8, minWidth: 0,
    borderTopWidth: embedded ? 1 : 0, borderTopColor: '#EBCB91' }}>
    <View style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 8 }}>
      {!embedded && <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants" style={{ marginTop: 2 }}>
        <FontAwesomeIcon icon={faCircleExclamation} size={16} color="#744200" />
      </View>}
      <Text accessibilityRole="header" style={{ color: '#5B3600', fontWeight: embedded ? '600' : '700', flex: 1,
        fontSize: embedded ? 14 : 13, lineHeight: embedded ? 20 : 18 }}>{t('quality-warning-label')}</Text>
    </View>
    <Text style={{ color: '#035164', fontSize: embedded ? 14 : 13, lineHeight: embedded ? 20 : 18 }}>{t('quality-warning-body')}</Text>
    <Pressable testID="quality-warning-action" accessibilityRole="button" accessibilityLabel={t('quality-warning-view')}
      onPress={open} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
      style={({ pressed }) => ({ minHeight: 44, flexDirection: 'row', alignItems: 'center', gap: 6,
        alignSelf: embedded ? 'stretch' : 'flex-start', maxWidth: '100%', justifyContent: embedded ? 'space-between' : 'flex-start',
        borderRadius: 4, borderWidth: embedded ? 0 : 2, borderColor: focused && !embedded ? '#035164' : 'transparent',
        marginLeft: embedded ? 0 : -2, paddingVertical: 8,
        backgroundColor: pressed || (embedded && focused) ? '#F4E2C4' : 'transparent' })}>
      <Text style={{ color: '#035164', fontSize: 14, lineHeight: 20,
        textDecorationLine: 'underline', fontWeight: embedded ? '600' : '400', flex: embedded ? 1 : undefined, flexShrink: 1 }}>{t('quality-warning-view')}</Text>
      {embedded && <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants">
        <FontAwesomeIcon icon={faChevronRight} size={14} color="#035164" />
      </View>}
    </Pressable>
  </View> : null;
}
